const menu = [
    {
        name: 'dashboard',
        parent: null,
        child: null,
        icon: 'tachometer-alt',
        permission_code: null
    },
    {
        name: 'chequeos',
        parent: true,
        child: [
            { name: 'distribution' },
            { name: 'project-mass' },
            { name: 'distribution-weighted' },
            { name: 'shopping-share' },
            { name: 'visibility' },
            { name: 'purchase' },
            { name: 'valued-purchase' },
            { name: 'price-average-moda' },
            { name: 'coexistence' },
            { name: 'multi-coexistence' },
            { name: 'summary-distribution' },
            { name: 'histogram-prices' },
            { name: 'histogram-prices-register' },
            { name: 'overlay-marks' },
            { name: 'breadth-sku-brands' }
        ],
        icon: 'folder',
        permission_code: 'VIEW_MOD_CHEQUEO_REPORT'
    },
    {
        name: 'chequeos-internal',
        parent: true,
        child: [
            { name: 'distribution-internal' },
            { name: 'project-mass-internal' },
            { name: 'distribution-weighted-internal' },
            { name: 'shopping-share-internal' },
            { name: 'visibility-internal' },
            { name: 'purchase-internal' },
            { name: 'valued-purchase-internal' },
            { name: 'price-average-moda-internal' },
            { name: 'coexistence-internal' },
            { name: 'multi-coexistence-internal' },
            { name: 'summary-distribution-internal' },
            { name: 'histogram-prices-internal' },
            { name: 'histogram-prices-register-internal' },
            { name: 'overlay-marks-internal' },
            { name: 'breadth-sku-brands-internal' },
            { name: 'breadth-attributes-brands-internal' }
        ],
        icon: 'folder',
        permission_code: 'VIEW_MOD_CHEQUEO_REPORT_INTERNAL'
    },
    {
        name: 'auditoria',
        parent: true,
        child: [
            { name: 'vta-val-inv' },
            { name: 'dn-ssn-dp' },
            { name: 'prices' },
            { name: 'vta-res-val-inv' }
        ],
        icon: 'folder',
        permission_code: 'VIEW_MOD_AUDIT_REPORT'
    },
    {
        name: 'auditoria-internal',
        parent: true,
        child: [
            { name: 'vta-val-inv-internal' },
            { name: 'dn-ssn-dp-internal' },
            { name: 'prices-internal' },
            { name: 'generate-data' },
            { name: 'vta-res-val-inv-internal' }
        ],
        icon: 'chart-line',
        permission_code: 'VIEW_MOD_AUDIT_REPORT_INTERNAL'
    },
    {
        name: 'administration',
        parent: true,
        child: [
            { name: 'customer' }
        ],
        icon: 'lock',
        permission_code: 'VIEW_MOD_ADM'
    },
    {
        name: 'poll',
        parent: true,
        child: [
            { name: 'request' },
            { name: 'planning'}
        ],
        icon: 'archive',
        permission_code: 'VIEW_MOD_ADM'
    },
    {
        name: 'analysis',
        parent: true,
        child:[
            { name: 'samples'},
            { name: 'base'},
            { name: 'purchase-inventory'}
        ],
        icon: 'archive',
        permission_code: 'VIEW_MOD_ADM'
        
    }

    /*
    {
        name:'surveys',
        parent:true,
        child:[
            { name:'survey-work-order' },
            { name:'survey-survey' },
            { name:'survey-sell-point'},
            { name:'survey-pollster' },
            { name:'survey-depuration'}
        ],
        icon:'poll'
    },
    {
        name:'maintenance',
        parent:true,
        child:[
            { name:'sell-points' },
        ],
        icon:'poll'
    } */
];

export default menu;